module.exports = __webpack_public_path__ + "img/tracking-removebg-preview (1).ccb218af.png";